import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../environments/environment';

@Pipe({
  standalone: true,
  name: 'gameThumbnail'
})
export class GameThumbnailPipe implements PipeTransform {

  transform(gameKey: string): any {
    return `${environment.api.endpoint}assets/game/uploads/${gameKey}`;
  }

}
